import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function ProtectedRoute({ children }) {
  const location = useLocation();
  const { isAuthenticated, isLoading, isLoggingOut } = useAuth();

  if (isLoading || isLoggingOut) {
    return <div className="portal-loading">{isLoggingOut ? 'Logging out...' : 'Loading...'}</div>;
  }

  if (!isAuthenticated) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }

  return children;
}
